import Service from '../Service'

function GetHeaderAndFooter() {
    return Service.get('PublicPage/GetHeaderAndFooter');
}

function GetPageByNameAndDepartmentId(name) {
    return Service.get('PublicPage/GetPageByPageNameAndDepartmentId?pageName=' + name);
}

const PageService = {
    GetHeaderAndFooter,
    GetPageByNameAndDepartmentId
};

export default PageService;
